export default __webpack_public_path__ + "static/media/custimage3.57ff165fc283756f1a492fb0edb48961.png";